import { array } from 'yup';

const marketplaceItemImages = array().required('At least one image is required.').min(1, 'At least one image is required.').nullable();

export { marketplaceItemImages };
